import Base from './base'
import { TaskParams } from '../types/task'

export default class CreateTask extends Base {
  createTask(payload: TaskParams): Promise<unknown> {
    return this.api.post('tasks', payload)
  }
}
